import React from 'react'
import { Box, Button, ButtonGroup, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import CONSTANTS from "../../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useCustomBackRouteNavigator } from "../../../../shared/hooks/use-route-navigator";

export const DisconnectionManagementFilters = ({ displayNullState }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const {
    searchParams: { tab: filterType = 'actionRequired' },
  } = useCustomBackRouteNavigator();
  const currentMonthYear = new Intl.DateTimeFormat("en-US", { month: "short", year: "numeric" }).format(new Date());

  const handleActionedClick = () => {
    navigate("?tab=actioned");
  };

  const handleActionRequiredClick = () => {
    navigate("?tab=actionRequired");
  };

  return (
    <>
      <Box className={styles.headerBox}>
        <Typography className={styles.headerDisconnectionMgmt}>Disconnection Management</Typography>
        {displayNullState ? null : (
          <Typography className={styles.boxItemEnd}>
            Displaying data for calendar month {currentMonthYear}
          </Typography>
        )}
      </Box>
      <Box className={styles.box}>
        <ButtonGroup variant="outlined" className={styles.buttonGroup}>
          <Button
            className={styles.buttonActionFilters}
            variant={filterType === CONSTANTS.DISCONNECTION_MANAGEMENT_FILTERS.ACTION_REQUIRED ? "contained" : "outlined"}
            color="primary"
            onClick={handleActionRequiredClick}>
            ACTION REQUIRED
          </Button>
          <Button
            className={styles.buttonActionFilters}
            variant={filterType === CONSTANTS.DISCONNECTION_MANAGEMENT_FILTERS.ACTIONED ? "contained" : "outlined"}
            color="primary"
            onClick={handleActionedClick}>
            ACTIONED
          </Button>
        </ButtonGroup>
      </Box>
    </>
  );
};
